import React, {useEffect, useRef, useState} from 'react';
import PopupSelectAdapter from "../PopupSelectAdapter";
import PropTypes from "prop-types";

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';
import PopupOptions from "../popup_select_component/PopupOptions";
import LinkForPopup from './link_implement/BusinessTypesPopupLinkForArticles';
import {fetchPopupData} from "../popup_select_component/fetchPopupData";
import PopupSelect from "../PopupSelect";
import ReactDOM from "react-dom";

const BusinessTypesRegistratorForArticles = props => {
  const [businessTypeIds, setBusinessTypeIds] = useState(props.business_type_ids || "");

  const url = (() => {
    const path = '/popup/member_business_types';
    const data = {
      selected_ids: businessTypeIds.split(","),
      is_limited_item: 0
    };
    return path + '?' + (new URLSearchParams(data)).toString();
  })();

  const onClosePopup = selectedBusinessTypes => {
    setBusinessTypeIds(selectedBusinessTypes.map(sBT => sBT.id).join(','));
  };

  const onChangeBusinessTypeIds = event => {
    setBusinessTypeIds(event.target.value);
  };

  return (
    <>
      <PopupSelectAdapter
        popupOptions={PopupOptions.businessTypes}
        fetchedData={fetchPopupData(url)}
        needSelectedAllButton={false}
        rootNode={document.querySelector('#popup_member_business_types')}
        onClosePopup={onClosePopup}
        selectedNames={props.input_industry_name}
        LinkForPopup={LinkForPopup}
        ButtonArea={ButtonArea}

      />
      <input type="hidden"
             name="article[article_business_types_ids]"
             onChange={onChangeBusinessTypeIds}
             value={businessTypeIds}
      />
    </>
  );
};

BusinessTypesRegistratorForArticles.propTypes = {
  business_type_ids: PropTypes.string,  // ie. "1,2,3"
  input_industry_name: PropTypes.string  // ie. "name1/name2/name3"
};

const ButtonArea = props => {
  return <a className="select select-industry-btn" onClick={props.onClickCloseButton}>選択</a>
};

export default BusinessTypesRegistratorForArticles;
